export const packList = [
"single_red_deck.json",
"single_red_deck_no_jokers.json",
];